// Level flow:
// 1-5. 1 wish 5x
// 6-10. 2 wishes 5x
// 10-15. 3 wishes 5x
// 16-20. 3 wishes 5x but faster
// 21-25. 4 wishes 5x
// 26-30. 5 wishes 5x
// 7. 6 wishes 5x     
// 8. 6 wishes 5x but faster
// After that, repeat 8
const levelSettings = [
    { wishes: 1, spawnRate: 15 },
    { wishes: 1, spawnRate: 15 },
    { wishes: 1, spawnRate: 15 },
    { wishes: 1, spawnRate: 15 },
    { wishes: 1, spawnRate: 15 },

    { wishes: 2, spawnRate: 18 },
    { wishes: 2, spawnRate: 18 },
    { wishes: 2, spawnRate: 18 },
    { wishes: 2, spawnRate: 17 },
    { wishes: 2, spawnRate: 17 },

    { wishes: 3, spawnRate: 17 },
    { wishes: 3, spawnRate: 17 },
    { wishes: 3, spawnRate: 17 },
    { wishes: 3, spawnRate: 16 },
    { wishes: 3, spawnRate: 16 },

    { wishes: 3, spawnRate: 15 },
    { wishes: 3, spawnRate: 15 },
    { wishes: 3, spawnRate: 15 },
    { wishes: 3, spawnRate: 15 },
    { wishes: 3, spawnRate: 15 },

    { wishes: 4, spawnRate: 15 },
    { wishes: 4, spawnRate: 15 },
    { wishes: 4, spawnRate: 15 },
    { wishes: 4, spawnRate: 15 },
    { wishes: 4, spawnRate: 15 },

    { wishes: 5, spawnRate: 15 },
    { wishes: 5, spawnRate: 15 },
    { wishes: 5, spawnRate: 15 },
    { wishes: 5, spawnRate: 14 },
    { wishes: 5, spawnRate: 14 },

    { wishes: 6, spawnRate: 14 },
    { wishes: 6, spawnRate: 14 },
    { wishes: 6, spawnRate: 14 },
    { wishes: 6, spawnRate: 14 },
    { wishes: 6, spawnRate: 14 },

    { wishes: 6, spawnRate: 13 },
    { wishes: 6, spawnRate: 13 },
    { wishes: 6, spawnRate: 12 },
    { wishes: 6, spawnRate: 12 },
    { wishes: 6, spawnRate: 11 },

    { wishes: 6, spawnRate: 11 },
    { wishes: 6, spawnRate: 11 },
    { wishes: 6, spawnRate: 10 },
    { wishes: 6, spawnRate: 10 },
    { wishes: 6, spawnRate: 9 },

    { wishes: 6, spawnRate: 9 },
    { wishes: 6, spawnRate: 8 },
    { wishes: 6, spawnRate: 8 },
    { wishes: 6, spawnRate: 7 },
    { wishes: 6, spawnRate: 7 },

    { wishes: 6, spawnRate: 6 },
    { wishes: 6, spawnRate: 6 },
    { wishes: 6, spawnRate: 5 },
    { wishes: 6, spawnRate: 5 },
    { wishes: 6, spawnRate: 5 },

    { wishes: 6, spawnRate: 5 },
    { wishes: 6, spawnRate: 5 },
    { wishes: 6, spawnRate: 5 },
    { wishes: 6, spawnRate: 5 },
    { wishes: 6, spawnRate: 5 },

    { wishes: 6, spawnRate: 1 }, // Never going to make this!
];

WL.registerComponent('level-controller', {
    listsControllerObject: { type: WL.Type.Object },
    giftsSpawnerObject: { type: WL.Type.Object },
}, {
    init: function () {
        this.listsController = this.listsControllerObject.getComponent('lists-controller');
        this.giftsSpawner = this.giftsSpawnerObject.getComponent('gift-spawner');
    },
    start() {
        window.SW.gameState.stateSubject.subscribe((state) => {
            if (state == State.gameplay) {
                this.startLevel();
            }
        });
    },

    startLevel() {
        this.level = 1;
        this.wishes = this.generateGifts(levelSettings[this.level - 1].wishes);
        this.listsController.setWishes(this.wishes);
        setTimeout(() => {
            this.giftsSpawner.startSpawning(this.wishes.map(w => w.gift),
                levelSettings[this.level - 1].spawnRate);
        }, 2000);
        window.SW.gameState.score = 0;
    },

    generateGifts(numberOfGifts) {
        let gifts = [];
        for (let i = 0; i < numberOfGifts; i++) {
            gifts.push({
                gift: ~~(Math.random() * 5),
                paper: ~~(Math.random() * 5),
                ribbon: ~~(Math.random() * 5),
            });
        }
        return gifts;
    },
    validate(gift, sack) {

        const checkWishes = {
            ToyTrain: 0,
            ToyHorse: 1,
            Star: 2,
            CandyCane: 3,
            ToyChest: 4
        }

        let wishIndex = checkWishes[gift.gift];
        let paperIndex = papers[gift.paper];
        let ribbonIndex = ribbons[gift.ribbon];

        let isValid = false;

        /* gift --  for example
        gift: "Star"
        paper: "blue"
        ribbon: "red"
        */

        /*
        sack1: wishes[2], wishes[5]
        sack2: wishes[0], wishes[3]
        sack3: wishes[1], wishes[4]
        */
        switch (sack) {
            case 2: // sack 1                
                if (this.check(2, wishIndex, paperIndex, ribbonIndex)) {
                    isValid = true;
                    this.wishes[2].crafted = true;
                }
                if (this.check(5, wishIndex, paperIndex, ribbonIndex)) {
                    isValid = true;
                    this.wishes[5].crafted = true;
                }
                break;
            case 1: // sack 2
                if (this.check(0, wishIndex, paperIndex, ribbonIndex)) {
                    isValid = true;
                    this.wishes[0].crafted = true;
                }
                if (this.check(3, wishIndex, paperIndex, ribbonIndex)) {
                    isValid = true;
                    this.wishes[3].crafted = true;
                }
                break;
            case 0: // sack 3
                if (this.check(1, wishIndex, paperIndex, ribbonIndex)) {
                    isValid = true;
                    this.wishes[1].crafted = true;
                }
                if (this.check(4, wishIndex, paperIndex, ribbonIndex)) {
                    isValid = true;
                    this.wishes[4].crafted = true;
                }
                break;
        }
        return isValid;
    },
    check(index, wishIndex, paperIndex, ribbonIndex) {
        return this.wishes[index] &&
            this.wishes[index].gift == wishIndex &&
            this.wishes[index].paper == paperIndex &&
            this.wishes[index].ribbon == ribbonIndex &&
            !this.wishes[index].crafted;
    },
    nextLevel() {
        if (this.wishes.filter(w => !w.crafted).length == 0) {
            this.level++;
            this.wishes = this.generateGifts(levelSettings[this.level - 1].wishes);
            this.listsController.setWishes(this.wishes);
            this.giftsSpawner.reset();
            this.giftsSpawner.startSpawning(this.wishes.map(w => w.gift),
                levelSettings[this.level - 1].spawnRate);
        }
    }

});

